<div class="list">
  <p *ngIf="rType == 0">Selecione uma finalidade para seu recebimento</p>
  <p *ngIf="rType == 1">Selecione uma finalidade para seu envio</p>

  <mat-radio-group [(ngModel)]="selectedFinality" class="radio-group">
    <div
      class="tappable hover"
      *ngFor="let finality of finalities"
      [ngClass]="
        finality?.id === selectedFinality?.id ? 'item-selected' : 'item'
      "
    >
      <div class="row" (click)="onFinalitySelect(finality)">
        <div
          [class]="
            isMobile
              ? 'col-auto align-self-center d-flex'
              : 'col-auto d-flex gap-8 align-self-center'
          "
        >
          <mat-radio-button
            [class]="isMobile ? '' : 'padding-left-24'"
            class="radio-button radio-list custom-radio-button"
            [value]="finality"
            (click)="$event.stopPropagation()"
          ></mat-radio-button>
          <img src="assets/image/market-icon.svg" />
        </div>
        <div [class]="isMobile ? 'col-7' : 'col-8'">
          <div class="d-flex flex-column">
            <p class="name mg-bottom-4">{{ finality.description }}</p>
            <p class="description p-text-grey-scale-dark">
              {{ finality.fullDescription }}
            </p>
          </div>
        </div>
        <div
          [class]="isMobile ? 'col-2' : 'col-1'"
          class="col-2 d-flex align-items-center justify-content-center"
        >
          <img src="assets/image/arrow-drawer.svg" />
        </div>
      </div>
    </div>
  </mat-radio-group>

  <div class="buttons border-grey-light">
    <div class="cols d-flex">
      <button
        (click)="closeModal()"
        type="button"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Cancelar
      </button>
      <button
        [disabled]="!selectedFinality"
        (click)="select(selectedFinality)"
        type="submit"
        class="btn btn-block mt-0 ml-3"
        [ngClass]="
          companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
        "
        type="button"
      >
        Continuar
      </button>
    </div>
  </div>
</div>
